import { useTheme } from '../../hooks/useTheme.jsx';
import { useI18n } from '../../i18n/i18n.jsx';

const ThemeToggle = () => {
  const { theme, toggleTheme, isDark } = useTheme();
  const { t } = useI18n();

  return (
    <button
      onClick={toggleTheme}
      className="relative inline-flex h-8 w-14 items-center rounded-full bg-neutral-200 dark:bg-neutral-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 dark:focus:ring-offset-neutral-900"
      aria-label={t('theme.toggle')}
      title={t('theme.toggle')}
    >
      <span className="sr-only">{t('theme.toggle')}</span>
      
      {/* Sun Icon (visible in light mode) */}
      <svg
        className={`absolute left-1.5 h-5 w-5 text-accent transition-all duration-300 ${
          isDark ? 'opacity-0 scale-50' : 'opacity-100 scale-100'
        }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
        />
      </svg>

      {/* Moon Icon (visible in dark mode) */}
      <svg
        className={`absolute right-1.5 h-5 w-5 text-accent transition-all duration-300 ${
          isDark ? 'opacity-100 scale-100' : 'opacity-0 scale-50'
        }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
        />
      </svg>

      {/* Toggle Circle */}
      <span
        className={`absolute h-6 w-6 rounded-full bg-white shadow-md transform transition-all duration-300 ${
          isDark ? 'translate-x-7' : 'translate-x-1'
        }`}
      />
    </button>
  );
};

export default ThemeToggle;
